import React from "react";
import { useParams } from "react-router-dom";
import { apiCallPost, indianRupee, niceDate, niceDateTime } from "../util/util";
import "../PurchaseOrder.css";
import QRCode from "react-qr-code";
import {
 Button,
 H3,
 H4,
 H5,
 H6,
 NonIdealState,
 Spinner,
} from "@blueprintjs/core";
import cogoToast from "cogo-toast";
import _ from "lodash";

function withRouter(Component) {
 function ComponentWithRouter(props) {
  let params = useParams();
  return <Component {...props} params={params} />;
 }
 return ComponentWithRouter;
}

class SMLowerOrder extends React.Component {
 state = { isLoading: true, isFailure: false, poId: null, hasLoaded: false };
 componentDidMount() {
  let ss = this.props.params.smId;
  this.setState({ poId: ss });
  if (ss) {
   this.getSubmission(ss);
  } else {
   this.setState({ isLoading: false, isInvalid: true });
  }
 }
 getSubmission = async (ss) => {
  try {
   let res = await apiCallPost("/print/ims2ShipmentManifest", {
    smId: ss,
   });
   this.setState({ isLoading: false, hasLoaded: true, ...res }, () => {
    this.addTerms();
    document.title = `${this.state.entityName} - ${this.state.branchInfo.hospital_name}`;
   });
  } catch (err) {
   cogoToast.error("Failed to load purchase order data.");
   this.setState({ isLoading: false, isFailure: true });
  }
 };
 addTerms = () => {
  this.setState({ tncs: [] });
 };
 renderHeader = () => {
  return (
   <div>
    <div
     style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
     }}
    >
     <div
      style={{
       display: "flex",
       flexWrap: "wrap",
       justifyContent: "flex-start",
      }}
     >
      <div
       style={{
        marginRight: "5px",
        marginBottom: "5px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
       }}
      >
       <img
        alt="Client Logo"
        src={this.state.branchInfo.logoUrl}
        height="85px"
        width="auto"
        className="img_block"
       />
       <b
        style={{
         fontSize: "9pt",
         marginTop: "3px",
         maxWidth: "120px",
         textAlign: "center",
        }}
       >
        {this.state.branchInfo.hospital_name}
       </b>
      </div>
      <div>
       <div style={{ textAlign: "left" }}>
        {this.renderHorizontalText("INTERNAL SHIPMENT MANIFEST")}
       </div>
       <b> {this.state.branchInfo.hospital_contact[0]}</b> <br />
       {this.state.branchInfo.hospital_contact[1]} <br />
       {this.state.branchInfo.hospital_contact[2]} <br />
       {this.state.branchInfo.hospital_contact[3]} <br />
      </div>
     </div>{" "}
     <div
      style={{
       display: "flex",
       flexWrap: "wrap",
       justifyContent: "flex-start",
       textAlign: "right",
       marginRight: "10px",
      }}
     >
      <div
       style={{
        // marginLeft: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "space-between",
        // textAlign: "right",
        maxWidth: "200px",
       }}
      >
       <div>
        <H5>INTERNAL SHIPMENT MANIFEST</H5>
        <H5>{this.state.entityName}</H5>
        <div>{niceDateTime(this.state.updatedAt)}</div>
        <div>Tracking Details : {this.state.trackingDetails}</div>
       </div>
      </div>
      <div
       style={{
        marginLeft: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
       }}
      >
       <QRCode
        size={80}
        value={`https://print.newchart.care/sm/${this.props.params.smId}`}
        level="H"
       />
       <div
        style={{
         fontSize: "x-small",
         wordBreak: "break-all",
         maxWidth: "150px",
         textAlign: "center",
        }}
       >
        <code> {this.state.poId}</code>
       </div>
      </div>
     </div>
    </div>
   </div>
  );
 };
 renderVendorAndReceivingRow = () => {
  return (
   <div>
    <div
     style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
     }}
    >
     <div
      style={{
       display: "flex",
       flexWrap: "wrap",
       justifyContent: "flex-start",
      }}
     >
      <div
       style={{
        marginRight: "5px",
        marginBottom: "5px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        maxWidth: "40vw",
       }}
      >
       <div>{this.renderHorizontalText("INTERNAL SHIPMENT FROM")}</div>
       <H5>
        {this.state.fromRecvLocation.branchName} | Store:
        {this.state.fromRecvLocation.branchStoreName}
       </H5>
       <div>{this.state.fromRecvLocation.branchShippingAddress}</div>
       <div>
        {this.renderContacts(this.state.fromRecvLocation.branchContacts)}
       </div>
      </div>
     </div>
     <div
      style={{
       display: "flex",
       flexWrap: "wrap",
       justifyContent: "flex-start",
      }}
     >
      <div
       style={{
        marginRight: "5px",
        marginBottom: "5px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-start",
        maxWidth: "40vw",
       }}
      >
       <div>{this.renderHorizontalText("INTERNAL SHIPMENT TO")}</div>
       <H5>
        {this.state.toRecvLocation.branchName} | Store:{" "}
        {this.state.toRecvLocation.branchStoreName}
       </H5>
       <div>{this.state.toRecvLocation.branchShippingAddress}</div>
       <div>
        {this.renderContacts(this.state.toRecvLocation.branchContacts)}
       </div>
      </div>
     </div>{" "}
    </div>
   </div>
  );
 };
 renderContacts = (list) => {
  if (!list) {
   return null;
  }
  if (!list.length) {
   return null;
  }
  return list.map((each, index) => {
   return (
    <div>
     Contact {index + 1}: {each.name} - {each.phone} - {each.email}
    </div>
   );
  });
 };
 renderItems = () => {
  if (!this.state.items || !this.state.items.length) {
   return null;
  }

  return (
   <div>
    <div>{this.renderHorizontalText("ITEMS")}</div>
    <table className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped">
     <thead>
      <tr>
       <th style={{ width: "5%" }}>#</th>
       <th style={{ width: "30%" }}>Item</th>
       <th style={{ width: "15%" }}>Category</th>
       <th style={{ width: "20%" }}>Serial Nos.</th>
       <th style={{ width: "10%" }}>Quantity</th>
       <th style={{ width: "10%" }}>Price</th>
       <th style={{ width: "20%" }}>Expiry Date</th>
      </tr>
     </thead>
     <tbody>
      {this.state.items.map((each, index) => (
       <tr key={index}>
        <td>{index + 1}</td>
        <td>{each.itemName}</td>
        <td>{each.itemCategory}</td>
        <td>{each.serialText}</td>
        <td>{each.quantity}</td>
        <td>
         {each.itemSalePriceFN?.toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
         })}
        </td>
        <td>{each?.itemExpiresOn ? niceDate(each?.itemExpiresOn[0]) : ""}</td>
       </tr>
      ))}
     </tbody>
    </table>
   </div>
  );
 };

 //   renderTotal = () => {
 //     let total = 0;
 //     if (!this.state.items) {
 //       return total;
 //     }
 //     if (!this.state.items.length) {
 //       return total;
 //     }
 //     for (var i = 0; i < this.state.items.length; i++) {
 //       total +=
 //         (this.state.items[i].price +
 //           (this.state.items[i].price * this.state.items[i].gst) / 100) *
 //         this.state.items[i].quantity;
 //     }
 //     return total;
 //   };
 renderTermsAndFooter = () => {
  return (
   <div>
    <div
     style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
     }}
    >
     <div
      style={{
       display: "flex",
       flexWrap: "wrap",
       justifyContent: "flex-start",
      }}
     >
      <div
       style={{
        marginRight: "5px",
        marginBottom: "5px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        maxWidth: "40vw",
       }}
      >
       <div>{this.renderTerms()}</div>
       <div>{this.renderEachTerm()}</div>
      </div>
     </div>{" "}
     <div
      style={{
       display: "flex",
       flexWrap: "wrap",
       justifyContent: "flex-start",
      }}
     >
      <div
       style={{
        marginRight: "5px",
        marginBottom: "5px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-start",
        maxWidth: "40vw",
       }}
      >
       {/* <div style={{ textAlign: "right" }}>
                {this.renderHorizontalText("E. & O. E.")}
              </div>
              <div style={{ textAlign: "right" }}>
                This is a computer generated purchase order and does not require
                a signature.
              </div>
              <div style={{ textAlign: "right" }}>
                In case of queries, please reach out to us.
              </div>
              <div style={{ textAlign: "right" }}>
                This order shall be governed by and construed in accordance with
                laws applicable in India and any arbitration will be resolved in
                the jurisdiction of the state of West Bengal.
              </div> */}
      </div>
     </div>{" "}
    </div>
   </div>
  );
 };
 renderTerms = () => {
  return <div>{this.renderHorizontalText("TERMS AND CONDITIONS")}</div>;
 };
 renderEachTerm = () => {
  return [
   <div>
    This is an internal shipment between two sites of the hospital for internal
    warehousing purposes and is not for sale or redistribution
   </div>,
  ];
 };
 renderEachItem = () => {
  if (!this.state.items || !this.state.items.length) {
   return null;
  }

  return this.state.items.map((each, index) => (
   <tr key={index} style={{ pageBreakInside: "avoid" }}>
    <td>{index + 1}</td>
    <td>{each.itemName}</td>
    <td>{each.itemCategory}</td>
    <td>{each.serialText}</td>
    <td>{each.quantity}</td>
    <td>{each?.itemExpiresOn ? niceDate(each?.itemExpiresOn[0]) : ""}</td>
   </tr>
  ));
 };
 renderVerticalText = (text, isProminent = true) => {
  return (
   <div
    style={{
     textAlign: "center",
     backgroundColor: "#E6E7E7",
     textOrientation: "upright",
     writingMode: "vertical-rl",
     marginRight: "10px",
     fontSize: "xx-small",
     border: `${isProminent ? "1px solid black" : ""}`,
    }}
   >
    {isProminent ? <b>{text}</b> : <>{text}</>}
   </div>
  );
 };
 renderHorizontalText = (text, isProminent = false) => {
  return (
   <div
    style={{
     textAlign: "center",
     backgroundColor: "#E6E7E7",
     marginBottom: "10px",
     fontSize: "xx-small",
     letterSpacing: "1mm",

     border: `${isProminent ? "1px solid black" : ""}`,
    }}
   >
    {isProminent ? <b>{text}</b> : <b>{text}</b>}
   </div>
  );
 };

 render() {
  if (this.state.isLoading || this.state.isFailure || !this.state.hasLoaded) {
   return (
    <div className="center_screen">
     <NonIdealState
      icon={this.state.isLoading ? <Spinner /> : "warning-sign"}
      title={
       this.state.isLoading
        ? "Loading..."
        : "We ran into an error. If you face this problem multiple times, please contact support."
      }
     />
    </div>
   );
  }

  return (
   <div className="rx__container">
    <style type="text/css" media="print">
     {`
            @page { 
              size: A4 portrait !important;
              margin: 7mm !important;
            }
  
            body {
              margin: 0;
              padding: 0;
            }
  
            table { 
              width: 100%;
              border-collapse: collapse;
            }
  
            thead {
              display: table-header-group;
            }
  
            tr {
              page-break-inside: avoid !important;
            }
  
            .no__print {
              display: none !important;
            }
          `}
    </style>

    <div className="main-content">
     <div className="no__print">
      <Button icon="print" text="Print" onClick={() => window.print()} fill />
      <br />
      <br />
     </div>

     {this.renderHeader()}
     <hr />
     {this.renderVendorAndReceivingRow()}
     <hr />
     {this.renderItems()}
     <hr />
     <div></div>
     {this.renderTermsAndFooter()}
    </div>
   </div>
  );
 }
}

const ShipmentManifest = withRouter(SMLowerOrder);
export default ShipmentManifest;
